import { messagesNow } from '@/i18n'
import { messages } from './messages'

interface SkipReason {
  text: () => string
  /** Повтор упрётся в тот же отказ — «Продолжить» тут бессмысленно. */
  final: boolean
}

/** Таблица — `Map`: у объектного литерала код `constructor` вернул бы функцию. */
const REASONS = new Map<string, SkipReason>([
  ['block_write_rejected', { text: () => messagesNow(messages).blockWriteRejected, final: true }],
])

/** Известный код → наш текст, иначе серверный `serverText` дословно. */
export const skipReasonText = (code: string | undefined, serverText: string): string =>
  (code === undefined ? undefined : REASONS.get(code)?.text()) ?? serverText

export const isFinalSkip = (code: string | undefined): boolean =>
  code === undefined ? false : (REASONS.get(code)?.final ?? false)
